import { useState } from "react";
import { LI, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import ProfileBox from "./ProfileBox";
import { useAuth } from "../../../../hooks/useAuth";

const UserProfile = () => {
  const { user } = useAuth();
  const [imageError, setImageError] = useState(false);

  // Obtener foto del usuario o usar imagen por defecto
  const defaultImage = dynamicImage("dashboard/profile.png");
  const userPhoto = (user?.photo_url && !imageError) ? user.photo_url : defaultImage;
  
  // Obtener nombre del usuario
  const userName = user?.name || user?.email || "Usuario";
  
  // Obtener rol del usuario
  const userRole = user?.role?.name || "Usuario";

  // Manejar error de carga de imagen
  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <LI className="profile-nav onhover-dropdown">
      <div className="media profile-media">
        <img
          className="b-r-10"
          src={userPhoto}
          alt={userName}
          onError={handleImageError}
        />
        <div className="media-body d-xxl-block d-none box-col-none">
          <div className="d-flex align-items-center gap-2">
            <span>{userName}</span>
            <i className="middle fa fa-angle-down"> </i>
          </div>
          <P className="mb-0 font-roboto">{userRole}</P>
        </div>
      </div>
      <ProfileBox />
    </LI>
  );
};

export default UserProfile;
